import * as React from "react";

import { Box, Card, CardContent, CardMedia, styled } from "@mui/material";

const CustomConvertibleCard = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  maxHeight: "600px",
  maxWidth: "400px",

  ".cardLayout": {
    padding: "10px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "10px",
    ".cardLayout": {
      padding: "6px",
    },
  },
}));

export default function ConvertibleCard({ imageSrc, position, children, details = {} }) {
  const isEular = details?.name === "Euler" ? true : false;
  return (
    <CustomConvertibleCard>
      <Card
        sx={{
          display: "flex",
          width: "100%",
          boxShadow: "none",
          minHeight: "140px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { sm: "row", md: "column" },
            width: "100%",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: {
                xs: "50%",
                md: "100%",
                justifyContent: "center",
                margin: "0px auto",
              },
            }}
            order={{ xs: position ?? 0, md: 0 }}
          >
            <CardMedia
              component="img"
              sx={{ width: isEular ? "100%" :  "85%" }}
              image={imageSrc}
              alt="Live from space album cover"
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              // alignItems: "center",
              // justifyContent:"center",
              width: { xs: "50%", md: "100%" },
              height: "132px",
            }}
            className="cardLayout"
          >
            <CardContent style={{ padding: "0px" }}>{children}</CardContent>
          </Box>
        </Box>
      </Card>
    </CustomConvertibleCard>
  );
}
